<template>
  <el-form ref="form" :model="model" class="search-bar-wrapper" label-position="top">
    <el-row class="el-form-row" :gutter="16">
      <slot></slot>
      <el-col :span="6">
        <el-form-item>
          <template #label><span>&nbsp;</span></template>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="resetFields">重置</el-button>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  name: 'searchWrapper',
  props: {
    model: { type: Object }
  },
  methods: {
    search() {
      this.$emit('search');
    },
    resetFields() {
      this.$refs.form.resetFields();
      this.$emit('search');
    }
  }
};
</script>

<style lang="scss" scoped>
.search-bar-wrapper {
  // display: flex;
  // flex-wrap: wrap;
  // gap: 0 16px;
  // align-items: center;
  margin-bottom: 10px;
  .el-form-row {
    width: 100%;
  }

  /deep/.el-form-item {
    margin-bottom: 10px;
    width: 100%;

    .el-form-item__label {
      padding: 0 0 5px 0;
      color: #262626;
      line-height: 20px;
    }

    .el-form-item__content {
      line-height: unset;
    }
  }
}
</style>
